import GlobalController from '../base-controllers/GlobalController';

const INTERACTIVE_ELEMENT_REGEX = /^(?:a|select|input|button|textarea)$/i;

/**
 * Controller for fixing the accessibility of internal hash links.
 *
 * - https://axesslab.com/skip-links/
 * - https://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
 */
export default class HashLinkFix extends GlobalController {
  static id = 'HashLinkFix';

  /**
   * DOM loaded.
   */
  init() {
    // Firefox and Chrome do the right thing. Possibly others, haven't tested.
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('firefox') === -1 && ua.indexOf('chrome') === -1) {
      // Run directly on page load to set focus if there is a hash in the URL
      this.focusLocationHash();
      this.on(window, 'hashchange', this.focusLocationHash);
    }
  }

  /**
   * Set focus to the element currently linked to.
   */
  focusLocationHash() {
    const id = window.location.hash.substring(1);
    if (id) {
      const el = document.getElementById(id);
      if (el) {
        if (!INTERACTIVE_ELEMENT_REGEX.test(el.tagName)) {
          el.tabIndex = -1;
        }

        el.focus();
      }
    }
  }
}
